module.exports = __webpack_public_path__ + "static/media/Iphone-spinner-2.e5e9172f.gif";